import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewProjectComponent } from './new-project.component';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import {AutoFocusModule} from 'primeng/autofocus';
import {CalendarModule} from 'primeng/calendar';
import { BasicProjectFormModule } from '../project/basic-project-form/basic-project-form.module';
import { ProgressBarModule } from 'primeng/progressbar';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    NewProjectComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    ProgressBarModule,
    BasicProjectFormModule,
    TranslateModule,
  ],
  exports: [
    NewProjectComponent
  ]
})
export class NewProjectModule { }
